import { Component } from 'react'
import { formatRank } from 'helpers/formatHelpers'
import Section from 'components/features/pfm/NetworthSummarySection/NetworthSummarySection'
import * as styles from 'components/features/pfm/NetworthRank/NetworthRank.css'

export type NetworthRankStateProps = {
  title: string
  value: number
  isOtherPeergroupSelected: boolean
}

export type NetworthRankDispatchProps = {
  onClick: () => void
}

export type NetworthRankProps = NetworthRankDispatchProps & NetworthRankStateProps

class NetworthRank extends Component<NetworthRankProps> {
  render () {
    const {
      title,
      value,
      isOtherPeergroupSelected,
      onClick,
    } = this.props
    const className = isOtherPeergroupSelected
      ? styles.otherPeers
      : styles.yourPeers

    return (
      <Section title={ title } onClick={ onClick }>
        <span className={ className }>
          { formatRank(value, true) }
        </span>
      </Section>
    )
  }

}

export default NetworthRank
